<div class="notify-popup-bg" (click)="!isLoading && close()" @opacityInOut></div>
<div class="notify-popup" [ngClass]="{ 'extract-skills-notifier': isSetOrUpdateJobPositionOnVacancy }" cdkTrapFocus cdkTrapFocusAutoCapture @scaleInOut>
  <button class="notify-popup__close" (click)="!isLoading && close()" [disabled]="isLoading" [attr.aria-label]="'Common.Close' | translate">
    <i class="app-ico-mask app-ico-mask__x"></i>
  </button>
  
  <h2 *ngIf="title && !showResult">{{ title }}</h2>
  <div *ngIf="msg && !showResult" [innerHTML]="msg"></div>
  <div class="input-wrapper" *ngIf="hasTextarea && !showResult">
    <a-textarea
      [label]="'NotifyPopup.WriteCorrection' | translate"
      [control]="control"
      [isSubmitted]="isSubmitted">
    </a-textarea>
    <div class="is-error" @slideInOut
      *ngIf="isSubmitted && control.errors && (control.errors['minlength'] || control.errors['maxlength'])">
      {{ 'NotifyPopup.MessageLength' | translate }} 
    </div>
  </div>

  <h2 *ngIf="resultTitle && showResult">{{ resultTitle }}</h2>
  <div *ngIf="resultMsg && showResult" [innerHTML]="resultMsg"></div>

  <a-checkbox
    *ngIf="checkboxStorageKey"
    [label]="checkboxLabel"
    (onChanged)="checkboxChange($event)">
  </a-checkbox>
  
  <div class="notify-popup__btns">
    <ng-container *ngIf="!showResult">
      <button type="button" class="is-btn is-btn__outfill" *ngIf="cancelLabel" [disabled]="isLoading" [class.is-disabled]="isLoading" tabindex="0" (click)="!isLoading && cancel()">{{ cancelLabel }}</button>
      <button type="button" class="is-btn"
        *ngIf="okLabel"
        tabindex="0"
        [disabled]="isLoading || (hasTextarea && !control.value)"
        [class.is-disabled]="isLoading || (hasTextarea && !control.value)"
        (click)="!isLoading && proceed()">
        <ng-container *ngIf="isLoading; else okText">
          {{ 'Common.Loading' | translate }}
        </ng-container>
        <ng-template #okText>
          {{ okLabel }}
        </ng-template>
      </button>
    </ng-container>
    <ng-container *ngIf="showResult">
      <button type="button" class="is-btn" tabindex="0" (click)="close()">{{ 'NotifyPopup.Okay' | translate }}</button>
    </ng-container>
  </div>
</div>